module.exports = __webpack_public_path__ + "static/MT_Process-07.685d3d5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/process-icons/MT_Process-07.png
// module id = 1504
// module chunks = 214286880276331